import React, { useEffect, useState } from 'react';
import { Link, usePage } from '@inertiajs/inertia-react';
import Layout from '../Shared/Layout';
import Imgix, { Background } from 'react-imgix';
import {BiChevronRight, BiPlay} from 'react-icons/bi';
import ServiceCountdownComponent from '../../ServiceCountdownComponent';
import List from '../Components/List/List';
import ListItem from '../Components/ListItem';
import { useViewport } from '../Shared/Helpers';

const localStorageAvailable = () => {
    if (typeof(Storage) !== "undefined") {
        return true;
    }
    else {
        return false;
    }
}

const HeroVideo = ({ item }) => {

  const loopingVideos = [
    'https://jpm4-production.imgix.net/cms/homepage/preachingloop1-20221108032910.mp4',
    'https://jpm4-production.imgix.net/cms/homepage/preachingloop2-20221108032909.mp4',
    'https://jpm4-production.imgix.net/cms/homepage/preachingloop3-20221108032909.mp4',
    'https://jpm4-production.imgix.net/cms/homepage/preachingloop4-20221108032909.mp4',
    'https://jpm4-production.imgix.net/cms/homepage/preachingloop5-20221108032908.mp4',
    'https://jpm4-production.imgix.net/cms/homepage/preachingloop6-20221108032908.mp4',
    'https://jpm4-production.imgix.net/cms/homepage/preachingloop7-20221108032907.mp4'
  ];
  const random = Math.floor(Math.random() * loopingVideos.length);

  return (
    <div className='row mt-4'>
      <div className='col'>
        <Link
          href={`/on-demand/watch/${item.slug}`}
          // style={{backgroundImage:`url(${item.thumbnailMaxUrl}`}}
          className='rounded-lg card w-full mb-5 md:p-5 home__hero bg-center bg-cover'
        >
          <video
            className='video-cover rounded-lg'
            src={loopingVideos[random]}
            autoPlay={true}
            loop={true}
            muted={true}
            controlsList={'nodownload'}
            playsInline={true}
            poster={'https://jpm4-production.imgix.net/cms/homepage/heroplaceholder-20221201063351.png'}
          ></video>
          <div className='card-body justify-end p-4 pr-12 z-[50]'>
            <p className='text-xs font-bold text-success grow-0'>NEW</p>
            <h1 className='card-title text-3xl lg:text-4xl  font-bold text-white'>
              {item.title}
            </h1>
            {item.episode_identifier && (
              <p className='grow-0 text-sm text-white pb-1'>
                {item.episode_identifier_string}
              </p>
            )}
            <div className='card-actions'>
              <button type='button' className='btn btn-secondary'>
                <BiPlay size='32px' className='pr-1' />
                Watch Now
              </button>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

const FeaturedBanner = ({
                          prefix,
                          headline,
                          backgroundImage,
                          overlayImage,
                          buttonText,
                          buttonUrl
                        }) => {
  const { imgixURL } = usePage().props;

  return (
    <>
      {/* mobile */}
      <Background
        className="md:hidden mt-5 rounded-lg card w-auto mb-5 text-center"
        src={`https://${imgixURL}/${backgroundImage}`}
        imgixParams={{
          auto: 'format',
          fit: 'crop',
          crop: 'center',
          blend: '000',
          bm: 'normal',
          balph: '40'
        }}
        sizes='100vw'
      >
        <a href={buttonUrl} className='card-body justify-space-around p-4'>
          <p className='font-bold text-center capitalize text-white'>
            {prefix}
          </p>
          <h2 className='card-title text-2xl font-bold text-center justify-center capitalize text-white mb-2'>
            {headline}
          </h2>
          <figure>
            <Imgix
              className='max-w-[300px]'
              sizes='(min-width: 1200px) 300px, (min-width: 992px) 300px, (min-width: 768px) 300px, (min-width: 576px) 80vw, 80vw'
              src={`https://${imgixURL}/${overlayImage}`}
              alt={headline}
            />
          </figure>
          <div className='card-actions text-center mt-4 mb-4'>
            <button className='btn btn-secondary m-auto'>{buttonText}</button>
          </div>
        </a>
      </Background>
      {/* desktop */}
      <Background
        className='hidden md:flex rounded-lg card mt-4 mb-6 lg:mb-8 w-full p-4'
        src={`https://${imgixURL}/${backgroundImage}`}
        imgixParams={{
          auto: 'format',
          fit: 'crop',
          crop: 'center',
          blend: '000',
          bm: 'normal',
          balph: '40'
        }}
        sizes='100vw'
      >
        <div className='row'>
          <a href={buttonUrl} className='col-6 flex justify-center'>
            <figure>
              <Imgix
                className='max-w-[300px]'
                sizes='(min-width: 1200px) 300px, (min-width: 992px) 300px, (min-width: 768px) 300px, (min-width: 576px) 80vw, 80vw'
                src={`https://${imgixURL}/${overlayImage}`}
                alt={headline}
              />
            </figure>
          </a>
          <a href={buttonUrl} className='col-6 flex flex-col justify-center'>
            <p className='font-bold capitalize text-white'>{prefix}</p>
            <h2 className='card-title text-3xl font-bold capitalize text-white mb-2'>
              {headline}
            </h2>
            <div className='card-actions'>
              <button className='btn btn-secondary'>{buttonText}</button>
            </div>
          </a>
        </div>
      </Background>
    </>
  );
};

const Home = ({ channels, jpmChannelVideos, playlists, featuredOffers, dailyCountdownData }) => {
  const { isLoggedIn, imgixURL } = usePage().props;
  const { width } = useViewport();
  const [openWelcomeModal, setOpenWelcomeModal] = useState(false);

  const closeWelcomeModal = () => {
    setOpenWelcomeModal(false);
    if(localStorageAvailable()){
        localStorage.setItem('openWelcomeModal','false');
    }
  }

  // if user already dismissed the pop-up on this device, don't show pop-up
  useEffect(() => {
    if(localStorageAvailable()){
        if(localStorage.getItem('openWelcomeModal') != 'false'){
            setOpenWelcomeModal(true);
        } 
    } else {
        setOpenWelcomeModal(true);
    }
  }, [])

  return (
    <>
      <div className='container' data-theme='jpm'>

        <HeroVideo item={jpmChannelVideos[0]} />
          {playlists &&
              playlists.map((item, index) => (
                  <div key={index}>
                      <div className='row'>
                          <div className='col-8'>
                              <h2 className='text-xl font-bold'>{item.title}</h2>
                              <div className='row mt-1 mb-2'>
                                  <div className='col'>
                                      <p className={'text-sm text-left text-neutral-content'}>{item.description}</p>
                                  </div>
                              </div>
                          </div>
                          <div className='col-4 text-right text-base font-medium flex justify-end items-center pt-px'>
                              <Link href={`/on-demand/playlist/${item.slug}`} className='text-primary'>
                                  See all
                              </Link>
                          </div>
                      </div>
                      <List
                          showRegisterOverlay={false}
                          isLoggedIn={isLoggedIn}
                          elements={item.playlistVideos}
                          playlistId={item.playlistId}
                          totalElements={item.playlistVideos.length}
                          viewportWidth={width}
                          listItem={el => <ListItem
                              imageUrl={el.thumbnail_url}
                              title={el.title}
                              isHorizontalScroll={width >= 768}
                              sermonId={el.is_episode && el.episode.episode_identifier_string}
                              date={el.is_episode ? el.youtube_published_at_diff: el.youtube_published_at}
                              link={'/on-demand/watch/' + el.slug}
                              videoDuration={el.video_duration ?? ''}
                              itemIsLocked={!isLoggedIn && el.is_locked}
                            />}
                      />
                      <div className={`col-12 pt-2 md:pt-6 pb-6`}>
                          <div className='w-full border-b border-solid border-[#7D7D7D]'></div>
                      </div>
                  </div>
              ))}
        
        <ServiceCountdownComponent
          isEnabled={dailyCountdownData?.isEnabled}
          nextServiceTimeText={dailyCountdownData?.nextServiceTimeText} 
          isServiceLiveNow={dailyCountdownData?.isServiceLiveNow} 
          initialDaysLeft={dailyCountdownData?.daysLeft} 
          initialHoursLeft={dailyCountdownData?.hoursLeft} 
          initialMinutesLeft={dailyCountdownData?.minutesLeft} 
          initialSecondsLeft={dailyCountdownData?.secondsLeft} /> 

        <div>
            <div className='flex items-center justify-between'>
                <h2 className='text-xl font-bold'>Featured Offers</h2>
                <a href={'/offers'} className='text-primary'>
                    See all
                </a>
            </div>
            <List
                isLoggedIn={isLoggedIn}
                elements={featuredOffers}
                totalElements={featuredOffers.length}
                viewportWidth={789}
                listItem={el => (
                    <ListItem
                        imageUrl={`https://${imgixURL}/${el.cover_image}`}
                    heading={'Featured Offer'}
                    title={el.title}
                    isHorizontalScroll={true}
                    description={el.shortDescription}
                    link={el.link}
                />)}
            />
            <div className={`col-12 pt-2 md:pt-6 pb-6`}>
                <div className='w-full border-b border-solid border-[#7D7D7D]'></div>
            </div>
        </div>

        <div>
          <h2 className='text-xl font-bold'>Channels</h2>
          <div className='row mt-1 mb-2'>
            <div className='col'>
              <p className={'text-sm text-left text-neutral-content'}>
                Discover more grace-based content from our different channels.
              </p>
            </div>
          </div>
          <List
            isLoggedIn={isLoggedIn}
            elements={channels}
            totalElements={channels.length}
            viewportWidth={width}
            listItem={el => <ListItem
              imageUrl={`https://${imgixURL}/${el.largeThumbnail}`}
              title={el.title}
              isHorizontalScroll={width >= 768}
              description={el.shortDescription}
              link={
                el.slug == 'joseph-prince-ministries'
                  ? '/on-demand/latest'
                  : '/on-demand/channel/' + el.slug
              }
            />}
          />
          <div className={`col-12 pt-2 md:pt-6 pb-6`}>
            <div className='w-full border-b border-solid border-[#7D7D7D]'></div>
          </div>
        </div>

        {/* Welcome Modal 
        <div className={`modal z-[100000] items-start md:items-center ` + (openWelcomeModal ? 'modal-open' : '')} onClick={() => closeWelcomeModal()} style={{backgroundColor: 'rgba(40,40,42,0.8)'}}>
            <div className="modal-box max-w-sm relative bg-neutral rounded p-0 mt-2 md:mt-0" onClick={() => closeWelcomeModal()}>
                <button onClick={() => closeWelcomeModal()} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent border-none">✕</button>
                <div style={{backgroundImage: 'url("/assets/images/newondemand.jpg")'}} className="bg-cover bg-center bg-no-repeat h-64 items-start no-underline">
                </div>
                <div className="p-4">
                    <h2 className="font-extrabold text-2xl text-center leading-8 mt-2 mb-4">
                        Introducing our new <br/>On Demand Experience
                    </h2>
                    <div className="pl-2 pr-2 pb-3">
                        <img src="/assets/images/newondemand-icon1.png" width="24" className="mr-1 float-left" />
                        <div className="ml-[38px] text-sm">Reimagined for a better viewing experience</div>
                    </div>
                    <div className="pl-2 pr-2 mb-4">
                        <img src="/assets/images/newondemand-icon2.png" width="24" className="mr-1 float-left"  />
                        <div className="ml-[38px] text-sm">Discover new content across different channels</div>
                    </div>
                    <button className="btn btn-primary w-full" onClick={() => closeWelcomeModal()}>Get Started</button>
                </div>
            </div>
        </div>
        */ }
      </div>
    </>
  );
};

// Persistent layout Docs: https://inertiajs.com/pages#persistent-layouts
Home.layout = (page) => (
  <Layout title="Watch Joseph Prince Broadcast" isHome={true} children={page} data-theme='jpm' />
);

export default Home;
